import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Asset, Photo } from '../../core/store/models';
import { SavingMessage } from '../../core/store/types';

@Component({
    templateUrl: './photo-upload-modal.component.html',
    standalone: false
})
export class PhotoUploadModalComponent implements OnInit {
    accept: string;
    asset: any;
    assets: any;
    disableUpload = false;
    title: string;
    saveMessage: SavingMessage[] = [];

    constructor(@Inject(MAT_DIALOG_DATA) private data: any, public dialogRef: MatDialogRef<PhotoUploadModalComponent>) { }

    ngOnInit() {
        this.title = 'Upload Asset Photos';
        if (this.data.asset) {
            this.asset = new Asset(this.data.asset);
        }
        else if (this.data.assets) {
            this.assets = this.data.assets;
        }
    }

    onBeforeUpload(event: { formData: FormData }) {
        if (this.data.assets) {
            event.formData.append('studio_id', this.asset.studio_id);
            event.formData.append('asset_id', this.assets[0].id);
            event.formData.append('asset_ids', this.assets.map(a => a.id).join(','));
            this.disableUpload = true;
        }
        else {
            event.formData.append('studio_id', this.asset.studio_id);
            event.formData.append('asset_id', this.asset.id);
            this.disableUpload = true;
        }
    }

    afterUpload(photos: Photo[]) {
        this.dialogRef.close(photos);
    }

    savingMessage(message) {
        this.saveMessage = message;
    }
}
